import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { map } from 'rxjs/operators';
import { IEvent } from '../models/IEvent';

@Injectable({
  providedIn: 'root'
})
export class EventService {

  constructor(private db: AngularFirestore) { }

  ref = this.db.collection('events');

  getAll() {
    return this.ref.snapshotChanges().pipe(map(actions => {
      return actions.map(action => {
        return {id: action.payload.doc.id, ...action.payload.doc.data() as IEvent};
      });
    }));
  }

  getAllOwn() {
    return this.ref.snapshotChanges().pipe(map(actions => {
      return actions.map(action => {
        return {theme: action.payload.doc.data()['theme'], items: action.payload.doc.data()['items']};
      });
    }));
  }

  get(id: string) {
    return this.ref.doc(id).snapshotChanges().pipe(map(action => {
      return {id: action.payload.id, ...action.payload.data() as IEvent};
    }));
  }

  toggleVisibility(id: string, value: boolean) {
    return this.ref.doc(id).update({active: !value});
  }
}
